<!--
  TODO(BREW-577): copied from facebook card.
  - Need to verify that all the various Instagram states are handled here, if
    they differ from Facebook states.
-->
<mat-card>
  <mat-card-header>
    <mat-icon mat-card-avatar class="instagram"></mat-icon>
    <glxy-badge *ngIf="badgeValue() !== null && !loadingAccounts() && !loadingPage()" [color]="badgeValue()!.color">
      {{ badgeValue()!.i18nKey | translate }}
    </glxy-badge>
    <mat-card-title>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="loading-state" *ngIf="loadingAccounts() || loadingPage()">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    <ng-container *ngIf="!loadingAccounts() && !loadingPage()">
      <p>
        <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.DESCRIPTION' | translate }}</strong>
      </p>
      <p *ngIf="noPages()">
        {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.DISCONNECTED_DESCRIPTION' | translate }}
      </p>
      <p class="page-name" *ngIf="pageName()">
        <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.INSTAGRAM_PAGE_NAME' | translate }}:</strong>&nbsp;
        @if (pageUrl()) {
          <a href="{{ pageUrl() }}" target="_blank">{{ pageName() }}</a>
        } @else {
          <span>{{ pageName() }}</span>
        }
      </p>
      <p [ngSwitch]="buttonToDisplay()" class="actions">
        <button *ngSwitchCase="'enable'" mat-flat-button color="primary" (click)="connect()">
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.TURN_ON_MESSAGING' | translate }}
        </button>
        <button *ngSwitchCase="'sign-in'" mat-flat-button color="primary" (click)="authClick()">
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.SIGN_IN_TO_INSTAGRAM' | translate }}
        </button>
        <button
          *ngSwitchCase="'disable'"
          mat-stroked-button
          [glxyPopover]="disconnectPopover"
          (click)="disconnectPopover.open()"
        >
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.DISCONNECT' | translate }}
        </button>
      </p>
      <glxy-alert
        *ngIf="unknownError() && !noPages()"
        type="error"
        actionTitle="{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.SIGN_IN_TO_INSTAGRAM' | translate }}"
        (actionClick)="authClick()"
        showAction
      >
        <p>
          <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.UNKNOWN_ERROR' | translate }}</strong>
          <br />
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.PLEASE_TRY_RECONNECTING' | translate }}
        </p>
      </glxy-alert>
      <glxy-alert *ngIf="authError() && !noPages()" type="error">
        <p>
          <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.PERMISSIONS_ERROR' | translate }}</strong>
          <br />
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.PERMISSIONS_ERROR_DESCRIPTION' | translate }}
        </p>
      </glxy-alert>
      <glxy-alert
        *ngIf="authTokenMissingPermissions() && !noPages()"
        type="error"
        actionTitle="{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.RECONNECT' | translate }}"
        (actionClick)="authClick()"
        showAction
      >
        <p>
          <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.PERMISSIONS_ERROR' | translate }}</strong>
          <br />
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.ERRORS.RECONNECT_TO_GRANT_PERMISSIONS' | translate }}
        </p>
      </glxy-alert>
      <glxy-alert *ngIf="manyPages() && !messengerEnabled()" type="warning">
        <p>
          <strong>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.WARNINGS.MULTIPLE_PAGES_LINKED' | translate }}</strong>
          <br />
          {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.WARNINGS.MULTIPLE_PAGES_LINKED_DESCRIPTION' | translate }}
          <span
            [innerHTML]="
              'INBOX.SETTINGS.INSTAGRAM_MESSAGES.WARNINGS.MULTIPLE_PAGE_FIRST_SELECTED'
                | translate: { pageName: this.pageName() }
            "
          ></span>
        </p>
      </glxy-alert>
    </ng-container>
  </mat-card-content>
</mat-card>

<glxy-popover #disconnectPopover>
  <glxy-popover-title>{{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.DISCONNECT_TITLE' | translate }}</glxy-popover-title>
  {{ 'INBOX.SETTINGS.INSTAGRAM_MESSAGES.DISCONNECT_DESCRIPTION' | translate }}
  <glxy-popover-actions>
    <button mat-stroked-button (click)="disconnectPopover.close()">{{ 'INBOX.CANCEL' | translate }}</button>
    <button mat-flat-button color="warn" (click)="disconnect(); disconnectPopover.close()">
      {{ 'INBOX.SETTINGS.DISCONNECT' | translate }}
    </button>
  </glxy-popover-actions>
</glxy-popover>
